import { render, staticRenderFns } from "./pi-share-detail.vue?vue&type=template&id=272499df&"
import script from "./pi-share-detail.vue?vue&type=script&lang=ts&"
export * from "./pi-share-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports